import {
  FETCH_SINGLE_USER,
  FAIL_REQUEST,
  MAKE_REQUEST,
  SET_EMPLOYEE_LIST,
  SET_DUPLICATE_USER_STATUS,
  SET_EMPLOYEE_AS_UNIT_LIST,
  EMAIL_LOGS_LIST,SET_USER_DATA
} from "./actionTypes";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setInValidUser } from "../authActions/authAction";
import * as constantMessages from "../../../constants/constatntMessages";
import { handleApiError } from "../../../helpers/errorResponseHelper";

export const makeRequest = () => {
  return {
    type: MAKE_REQUEST,
  };
};
export const failRequest = (err) => {
  return {
    type: FAIL_REQUEST,
    payload: err,
  };
};
export const fetchSingleUser = (data) => {
  return {
    type: FETCH_SINGLE_USER,
    payload: data,
  };
};

export const viewSingleUser = (userId, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());

    const url = `${process.env.REACT_APP_API_URL}/api/V1/employee/viewSingleEmployee/${userId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };
    axios
      .get(url, headerObject)
      .then((res) => {
        const resData = res.data;

        let data;
        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        } else {
          dispatch(setInValidUser(false));
        }
        if (resData.success) {
          dispatch(fetchSingleUser(resData));
        } else {
          dispatch(fetchSingleUser(resData));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const getEmployeeListAsPerUnit = (
  payload,
  meetingCreatedById,
  accessToken
) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/employee/getEmployeeListAsPerUnit/${payload.unitId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };
    const bodyPayload = {
      meetingCreatedById: meetingCreatedById ? meetingCreatedById : undefined,
    };

    axios
      .post(webApiUrl, bodyPayload, headerObject)
      .then((result) => {
        const resData = result.data;
        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(setEmployeeListAsPerUnit(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const setEmployeeListAsPerUnit = (data) => {
  return {
    type: SET_EMPLOYEE_AS_UNIT_LIST,
    payload: data,
  };
};

export const getEmployeeList = (payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/employee/listOnlyEmployee/${payload.organizationId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .get(webApiUrl, headerObject)
      .then((result) => {
        const resData = result.data;
        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(setEmployeeList(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
      });
  };
};

export const setEmployeeList = (data) => {
  return {
    type: SET_EMPLOYEE_LIST,
    payload: data,
  };
};

export const checkDuplicateUser = (payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/employee/checkDuplicateUser`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    return axios
      .post(webApiUrl, payload, headerObject)
      .then((result) => {
        const resData = result.data;
        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success && resData?.data?.isDuplicateUser === true) {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }

        dispatch(setDuplicateUserStatus(resData));
        return resData;
      })
      .catch((err) => {
        if (handleApiError(err)) return;
      });
  };
};

export const setDuplicateUserStatus = (data) => {
  return {
    type: SET_DUPLICATE_USER_STATUS,
    payload: data,
  };
};

export const setEmailLogsList = (data) => {
  return {
    type: EMAIL_LOGS_LIST,
    payload: data,
  };
};


export const setUserData = (data) => {
  return {
    type: SET_USER_DATA,
    payload: data,
  };
};

export const EmailLogsList = (payload, accessToken) => {
  return (dispatch) => {
    if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/emailLog/emailLogsList`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
      params: {
        limit: payload.limit,
        order: payload.order,
        page: payload.page,
      },
    };

    const bodyPayload = {
      searchKey: payload.searchKey ? payload.searchKey : undefined,
      toDate: payload.toDate ? payload.toDate : undefined,
      fromDate: payload.fromDate ? payload.fromDate : undefined,
      organizationId: payload?.organizationId,
    };

    if (payload?.organizationId) {
      return axios
        .post(webApiUrl, bodyPayload, headerObject)
        .then((result) => {
          const resData = result.data;

          if (resData.success === false && resData.data?.totalCount === 0) {
            dispatch(setEmailLogsList(resData));
            return { status: true };
          }

          if (
            (!resData.success && resData.data?.totalCount !== 0) ||
            resData.data?.isInValidUser
          ) {
            toast.error(resData.message, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }

          dispatch(setEmailLogsList(resData));
        })
        .catch((err) => {
          dispatch(failRequest(err.message));
          if (handleApiError(err)) return;
          if (!window.navigator.onLine) {
            toast.error(constantMessages.noInternetErrorMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            toast.error(constantMessages.serverErrorMessage + ' User Action', {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        });
    }
  };
};

export const updateEmployeeProfile = (
  employeeId,
  updateEmployee,
  accessToken
) => {
  return async (dispatch) => {
    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/V1/employee/updateProfile/${employeeId}`,
        updateEmployee,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: accessToken,
          },
        }
      );

      

      if (response.data.success) {
        dispatch(viewSingleUser(employeeId, accessToken));
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        return response.data.data.data;
      } else {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        return null;
      }
    } catch (error) {
      toast.error("Error updating employee profile", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      console.error("Error while updating Employee:", error);
      return null;
    }
  };
};
